export default "__VITE_ASSET__BkuD6A1Q__"